import { ROUTES } from "@src/constants/routes"

export const getClassNameActive = (data, currentPath) => {
  if (!currentPath) {
    return ""
  }

  if (data?.subMenu) {
    const subMenu = data?.subMenu?.find(item =>
      currentPath.startsWith(item.path)
    )
    if (subMenu) {
      return "active"
    }
  }

  if (
    data?.isHome &&
    ["/", "/#", ROUTES.BEST_SELLER, ROUTES.NEW_IN].includes(
      currentPath
    )
  ) {
    return "active"
  }

  if (!data?.isHome && currentPath.includes(data.path)) {
    return "active"
  }
  return ""
}


export const menuConfig = [
  {
    title: "home",
    key: "home",
    isHome: true,
    path: ROUTES.HOME_PAGE,
    isActive: true
  },
  {
    title: "COLLECTIONS",
    key: "collection",
    path: ROUTES.COLLECTION,
    isActive: true
  },
  {
    title: "products",
    key: "product",
    path: ROUTES.PRODUCT,
    isActive: true
  },
  {
    title: "Black Friday",
    key: "on_sale",
    path: ROUTES.ON_SALE,
    color: '#E51B24',
    isActive: true
  },
  {
    title: "EVENT",
    key: "event",
    path: ROUTES.EVENT,
    isActive: false
  },
  {
    title: "introduction",
    key: "introduction",
    path: ROUTES.ABOUT_US,
    isActive: true,
    subMenu: [
      {
        title: "ABOUT US",
        key: "about_us",
        path: ROUTES.ABOUT_US,
        isActive: true
      },
      {
        title: "policy_terms",
        key: "policy_terms",
        path: ROUTES.POLICY_TERMS,
        isActive: true,
        subMenu: [
          {
            title: "policy_terms_domestic",
            key: "policy_terms_domestic",
            path: ROUTES.SALE_POLICY,
            isActive: true
          },
          {
            title: "policy_terms_international",
            key: "policy_terms_international",
            path: ROUTES.POLICY_TERMS_INTERNATIONAL,
            isActive: true
          }
        ]
      },
      {
        title: "MEMBERSHIP",
        key: "membership",
        path: ROUTES.MEMBERSHIP,
        isActive: true
      },
      {
        title: "branches",
        key: "branch",
        path: ROUTES.BRANCH,
        isActive: true
      },
      {
        title: "recruitment",
        key: "recruitment",
        path: ROUTES.RECRUITMENT,
        isActive: true
      },
      {
        title: "FAQ",
        key: "faq",
        path: ROUTES.FAQ,
        isActive: true
      },
    ]
  }
]
